import { makeAutoObservable, observable } from 'mobx';
import { DialogResponseTypeEnum } from '../enums/dialog-response-type.enum';
import { RootStore } from './root.store';

export type ModalActionItem = {
  icon: React.ReactNode;
  tooltipText: string;
  onClick: () => void;
};

export type UiStoreModalType = {
  component: React.ReactNode;
  title?: string;
  fullScreen?: boolean;
  backdropClose?: boolean;
  actionItems?: ModalActionItem[];
  blockClose?: boolean;
};

export type UiStoreDialogType = {
  title: string;
  message: string;
  withReason?: boolean;
};

export type DialogResponseType = {
  value: DialogResponseTypeEnum;
  reason?: string;
};

export class UiStore {
  private _rootStore: RootStore;

  /** modal */
  modalOpen: boolean = false;
  currentModal: UiStoreModalType | null = null;

  /** dialog */
  dialogActive: boolean = false;
  dialogResFunction: ((response: DialogResponseType) => void) | null = null;
  currentDialog: UiStoreDialogType | null = null;

  /** iframe */
  iframeOpen: boolean = false;
  iframeUrl: string = '';

  constructor(rootStore: RootStore) {
    this._rootStore = rootStore;
    makeAutoObservable(this, {
      currentModal: observable.ref
    });
  }

  updateModal(modalOptions: Partial<Omit<UiStoreModalType, 'component'>>) {
    if (!this.currentModal) return;

    this.currentModal = {
      ...this.currentModal,
      ...modalOptions
    };
  }

  openModal(modalProps: UiStoreModalType) {
    /** hide the scroll bar behind the panel */
    document.body.style.overflow = 'hidden';

    this.modalOpen = true;
    this.currentModal = modalProps;
  }

  dismissModal() {
    /** hide the scroll bar behind the panel */
    document.body.style.overflow = 'auto';
    this.modalOpen = false;
    this.currentModal = null;
  }

  openIframe(url: string){
    this.iframeOpen = true;
    this.iframeUrl = url;
  }

  dismissIframe(){
    this.iframeOpen = false;
    this.iframeUrl = '';
  }

  openDialog(props: UiStoreDialogType): Promise<DialogResponseType> {
    this.dialogActive = true;
    this.currentDialog = props;

    this.dialogResFunction = () => {};
    return new Promise<DialogResponseType>(resolve => {
      this.dialogResFunction = resolve;
    });
  }

  dismissDialog() {
    document.body.style.overflow = 'auto';
    this.dialogActive = false;
    this.currentDialog = null;
  }
}
